import { StyledIgnoredWrapper } from "app/pages/sales-intelligence/common-components/styles";
import type { UnknownProps } from "app/pages/sales-intelligence/types";
import type { ComponentType, MouseEventHandler } from "react";

type HocProps = {
    onMouseEnter?: MouseEventHandler;
    onMouseLeave?: MouseEventHandler;
};

const withMouseEventHandlers = <P extends UnknownProps>(Component: ComponentType<P>) => {
    return function WrappedWithMouseEventHandlers({ onMouseEnter, onMouseLeave, ...componentProps }: P & HocProps) {
        return (
            <StyledIgnoredWrapper
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <Component {...(componentProps as P)} />
            </StyledIgnoredWrapper>
        );
    };
};

export default withMouseEventHandlers;
